import { schemaMappingEnum } from './schema-mappings.js';
import { parseResponseReference } from './tool-response-projection.js';
export const AGENT_OUTCOME_REF_KEY = 'agentOutcome';
export const AGENT_OUTCOME_ENABLED_VALUE = 'enabled';
export const AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY = 'agentOutcomeResourceSchema';
export const AGENT_OUTCOME_RESOURCE_ID_OUTPUT_KEY = 'agentOutcomeResourceId';
export const AGENT_OUTCOME_RESOURCE_SCHEMA_CATEGORIES = [
    schemaMappingEnum.enum.contacts_schema,
    schemaMappingEnum.enum.transactions_schema,
    schemaMappingEnum.enum.locations_schema,
    schemaMappingEnum.enum.combined_schema,
    schemaMappingEnum.enum.custom_schema,
];
const agentOutcomeResourceSchemaCategories = new Set(AGENT_OUTCOME_RESOURCE_SCHEMA_CATEGORIES);
export function isAgentOutcomeResourceSchemaCategory(category) {
    return typeof category === 'string' && agentOutcomeResourceSchemaCategories.has(category);
}
export function readToolAgentOutcomeConfig(schemaMappingRefs) {
    if (schemaMappingRefs?.[AGENT_OUTCOME_REF_KEY] !== AGENT_OUTCOME_ENABLED_VALUE)
        return null;
    const schemaDefinitionId = schemaMappingRefs[AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY]?.trim();
    return {
        enabled: true,
        ...(schemaDefinitionId ? { resource: { schemaDefinitionId } } : {}),
    };
}
export function claimsToolAgentOutcome(schemaMappingRefs) {
    if (!schemaMappingRefs)
        return false;
    return (Object.prototype.hasOwnProperty.call(schemaMappingRefs, AGENT_OUTCOME_REF_KEY) ||
        Object.prototype.hasOwnProperty.call(schemaMappingRefs, AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY));
}
export function withToolAgentOutcome(args) {
    const schemaDefinitionId = args.resourceSchemaDefinitionId?.trim();
    const unrelatedRefs = Object.fromEntries(Object.entries(args.schemaMappingRefs ?? {}).filter(([key]) => key !== AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY));
    return {
        ...unrelatedRefs,
        [AGENT_OUTCOME_REF_KEY]: AGENT_OUTCOME_ENABLED_VALUE,
        ...(schemaDefinitionId ? { [AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY]: schemaDefinitionId } : {}),
    };
}
export function withoutToolAgentOutcome(schemaMappingRefs) {
    return Object.fromEntries(Object.entries(schemaMappingRefs ?? {}).filter(([key]) => key !== AGENT_OUTCOME_REF_KEY && key !== AGENT_OUTCOME_RESOURCE_SCHEMA_REF_KEY));
}
export function mapsAgentOutcomeResourceId(responseMapping) {
    if (!responseMapping)
        return false;
    const mapping = responseMapping[AGENT_OUTCOME_RESOURCE_ID_OUTPUT_KEY];
    if (typeof mapping !== 'string')
        return false;
    const parsedMapping = parseResponseReference(mapping);
    return parsedMapping.success && parsedMapping.tokens.every(token => token.type !== 'each');
}
export function requiresAgentOutcomeResourceIdMapping(schemaMappingRefs, responseMapping) {
    const config = readToolAgentOutcomeConfig(schemaMappingRefs);
    return config?.resource !== undefined && !mapsAgentOutcomeResourceId(responseMapping);
}
//# sourceMappingURL=tool-agent-outcome.js.map